module.exports = "/wp-content/plugins/farmacy/assets/js/images/indica_moon_icon-d5adb7bb83827e423254a249942d1157.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/modal/img/indica_moon_icon.png
 ** module id = 1040
 ** module chunks = 1 139
 **/